import React from "react"
import types from "prop-types"
import { isEmpty, isEqual, sortBy } from "lodash-es"
import { useSelector } from "react-redux"
import { groupsById } from "reduxSlices/groupsSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable max-len */
import TaskGroupList from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskGroupList"
/* eslint-enable max-len */

const TaskMemberGroupList = ({ className = "" }) => {
  const { removeMemberGroupId, taskMemberGroupIds } = useTaskFormContext()
  const memberGroups = useSelector(groupsById(taskMemberGroupIds), isEqual)

  if (isEmpty(taskMemberGroupIds)) return null

  const sortedMemberGroups = sortBy(memberGroups, ["name"])

  return (
    <div className={className}>
      <TaskGroupList className="mb-2" removeGroup={removeMemberGroupId} groups={sortedMemberGroups} groupDescriptor="member" />
      <p className="text-xs text-dark md:w-4/5">
        Each member group will have each of its members added to the task individually.
        Each group member will also be granted individual access to the form submission
        and be made a member of any tasks selected under &quot;Access to Other Tasks&quot;.
      </p>
    </div>
  )
}

TaskMemberGroupList.propTypes = {
  className: types.string,
}

export default TaskMemberGroupList
